"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BROADCAST_SET_SCREEN_SHARE_COUNT = void 0;
var BROADCAST_SET_SCREEN_SHARE_COUNT = exports.BROADCAST_SET_SCREEN_SHARE_COUNT = 'BROADCAST_SET_SCREEN_SHARE_COUNT';